import { ResourcesManager, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class SkipTimeComponentModel extends ViewerModule {
    constructor(componentRadius, options) {
        super();
        this.clock = ResourcesManager.getModel('MODEL_clock');
        this.clock.name = 'CLOCK';
        this.clock.scale.setScalar(0.025);
        this.addObject(this.clock);
        window['clock'] = this.clock;
        // @ts-ignore
        this.clock.getObjectByName('polySurface18').material.map = ResourcesManager.getTexture('MAP_clock_time');
        // @ts-ignore
        this.clock.getObjectByName('polySurface18').material.needsUpdate = true;
        // @ts-ignore
        this.clock.getObjectByName('polySurface19').material.map = ResourcesManager.getTexture('MAP_clock_body');
        // @ts-ignore
        this.clock.getObjectByName('polySurface19').material.needsUpdate = true;
        this.clock.getObjectByName('clockclockpCube2').visible = false;
        // let hourArrowColor = (options.hourArrow && options.hourArrow.color) || 0x000000;
        // let hourArrowThickness = (options.hourArrow && options.hourArrow.thickness) || componentRadius / 10;
        // let minutesArrowColor = (options.minutesArrow && options.minutesArrow.color) || 0x000000;
        // let minutesArrowThickness = (options.minutesArrow && options.minutesArrow.thickness) || componentRadius / 20;
        // let bodyColor = (options.body && options.body.color) || 0xffffff;
        // let markerColor = (options.markers && options.markers.color) || 0x000000;
        // let bodyBackColor = (options.body && options.body.border && options.body.border.color) || 0x000000;
        this.speedFactor = options.speedFactor || 1;
        // let body = new Mesh(new CircleGeometry(componentRadius, 32), new MeshBasicMaterial({color: bodyColor}));
        // let bodyBack = new Mesh(new CircleGeometry(componentRadius * 1.1, 32), new MeshBasicMaterial({color: bodyBackColor}));
        // bodyBack.position.set(0, 0, -0.03);
        // const geoHour = new PlaneGeometry(hourArrowThickness, componentRadius * 0.9);
        // geoHour.translate(0, componentRadius / 2, 0.02);
        // this.hourArrow = new Mesh(geoHour, new MeshBasicMaterial({color: hourArrowColor}));
        this.hourArrow = this.clock.getObjectByName('clockclockpCube3');
        // const geoMinute = new PlaneGeometry(minutesArrowThickness, componentRadius * 0.9);
        // geoMinute.translate(0, componentRadius / 2, 0.02);
        // this.minutesArrow = new Mesh(geoMinute, new MeshBasicMaterial({color: minutesArrowColor}));
        this.minutesArrow = this.clock.getObjectByName('clockclockpCube4');
        // let arrowCover = new Mesh(new CircleGeometry(componentRadius * 0.1, 16), new MeshBasicMaterial({color: hourArrowColor}));
        // arrowCover.position.set(0, 0, 0.03);
        // this.addObject(body);
        // this.addObject(bodyBack);
        // this.addObject(this.hourArrow);
        // this.addObject(this.minutesArrow);
        // this.addObject(arrowCover);
        // if (options.markers) {
        //     let markers = new Group;
        //     let markerOptions = [
        //         {
        //             move: new Vector3(0, componentRadius * 0.85, 0.01),
        //             rotationZ: 0,
        //             length: componentRadius * 0.2
        //         },
        //         {
        //             move: new Vector3(componentRadius * 0.85, 0, 0.01),
        //             rotationZ: -Math.PI / 2,
        //             length: componentRadius * 0.2
        //         },
        //         {
        //             move: new Vector3(0, -componentRadius * 0.85, 0.01),
        //             rotationZ: 0,
        //             length: componentRadius * 0.2
        //         },
        //         {
        //             move: new Vector3(-componentRadius * 0.85, 0, 0.01),
        //             rotationZ: Math.PI / 2,
        //             length: componentRadius * 0.2
        //         },
        //     ];
        //     // markerOptions.forEach((el) => {
        //     //     let mesh = new Mesh(new PlaneGeometry(options.markers ? options.markers.thickness : hourArrowThickness * 1.5, el.length), new MeshBasicMaterial({color: markerColor}));
        //     //     mesh.position.copy(el.move);
        //     //     mesh.rotateZ(el.rotationZ);
        //     //     markers.add(mesh);
        //     // });
        //     // this.addObject(markers);
        // }
    }
    start() {
        const startTime = Date.now();
        this.hourArrow.rotation.set(0, 0, 0);
        this.minutesArrow.rotation.set(0, 0, 0);
        let radInSec = Math.PI / 30 / 2;
        this.interval = setInterval(() => {
            const diff = ((Date.now() - startTime) / 1000) * this.speedFactor;
            this.hourArrow.rotation.z = diff / 60 * -radInSec;
            this.minutesArrow.rotation.z = diff * -radInSec;
        }, 50);
    }
    stop() {
        clearInterval(this.interval);
    }
}
